import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AdminBaseListComponent } from 'src/modules/sm-base/components/admin-base-list/admin-base-list.component';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableCellType } from 'src/modules/sm-base/netgen/TableCellType';
import { TableColumn } from 'src/modules/sm-base/netgen/TableColumn';
import { Objects } from "src/modules/utils/shared/objects";
import { ProjectPlanningTools } from '../../models/project-planning-tools.model';
import { Project } from '../../netgen/Project';
import { ProjectType } from '../../netgen/ProjectType';
import { ProjectPlanningService } from '../../services/project-planning.service';

@Component({
    selector: 'app-edit-projects',
    templateUrl: '../../../sm-base/components/admin-base-list/admin-base-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditProjectsComponent extends AdminBaseListComponent<Project> {

    service = inject(ProjectPlanningService);

    definition = ProjectPlanningTools.definitionProject;
    
    projectTypes: ProjectType[];
        
    
    getTable(): TableData {
        return this.app.tTable("entity.Project.fields", new TableData([
            new TableColumn("projectNumber", "", TableCellType.string, 14),
            new TableColumn("title", this.app.t("entity.Project.other.titleList"), TableCellType.string, 50),
            new TableColumn("projectType", this.app.t("entity.Project.fields.typeId"), TableCellType.string, 30)
        ], this.listData.map(o => new TableRow(Objects.toString(o.id), o, {
            projectNumber: o.projectNumber,
            title: o.title,
            projectType: this.service.getProjectType(o.typeId)?.title ?? ""
        })), ["projectNumber"]));
    }

    async initAdditionalData(): Promise<void> {
        await this.service.getProjectTypes();
    }

}
